import { useMemo } from "react";
import { useNotifications } from "./useNotifications";
import {
  countUnreadByTypes,
  countUnreadByTypesWhere,
} from "../utils/notificationTypes";

/**
 * Count unread notifications matching any of the given types.
 * Pass a stable `types` array (exported constants from notificationTypes.js).
 * Optional `predicate(notif)` further filters (e.g. buyer vs seller facing).
 */
export function useUnreadNotificationCount(types, predicate) {
  const { notifications } = useNotifications();
  return useMemo(() => {
    if (typeof predicate === "function") {
      return countUnreadByTypesWhere(notifications, types, predicate);
    }
    return countUnreadByTypes(notifications, types);
  }, [notifications, types, predicate]);
}
